// extracted by mini-css-extract-plugin
export default {"content":"LoginProforma_content__ldmmY","image":"LoginProforma_image__dIDmT"};